<template>
  <div>
    <div v-show="!$store.getters.appLoading">
        <div v-if="!focusMode" class="vx-row flex">
          <PlannerHeader class="mt-8 mb-4" @click="sidebarActive=true">dreams</PlannerHeader>

            <!-- <div v-if="dreamsPresent" class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 flex justify-end mb-4 margin-auto"> -->
                <!-- <ImportDreamDialog class="ml-1"/> -->
                <!-- <AddNew @addDream="sidebarActive=true" class="ml-2"/> -->
            <!-- </div> -->

        </div>
        <div v-if="!dreamsPresent">
          <EmptyState variant="4" title="Become the designer of your life." subtitle="Give yourself a destination, a point in the future to which you focus all your effort. Don't think about the 'how', think about the 'why'." subtitle2="Who do you want to become, what do you deeply want to experience in one year?"/>
<!--         <div class="py-5">
          <vs-row class="my-3" vs-type="flex" vs-align="center">
            <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                 <p>A dream is the GPS that guides you to the destination designed for your life.</p>
            </vs-col>
          </vs-row>

          <vs-row class="mt-5" vs-type="flex" vs-align="center">
            <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                 <p>What do you want to see, explore, do, and experience in your life?</p>
            </vs-col>
          </vs-row>

          <vs-row class="my-3" vs-type="flex" vs-align="center">
            <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                 <p>Focus on the things that are essential to live your best life.</p>
            </vs-col>
          </vs-row>
        </div> -->

<!--           <vs-row class="mt-3" vs-type="flex" vs-align="center">
            <vs-col class="my-3" vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
              <p class="emphasize">
                I know what I strive for.
              </p>
            </vs-col>

             <vs-col class="my-3" vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                <AddNew @addDream="sidebarActive=true" class="ml-2" title="Create My First Dream"/>
                </vs-col>
          </vs-row> -->

<!--           <div class="divider py-5">
            <vs-divider>OR</vs-divider>
          </div>
          <vs-row vs-type="flex" vs-align="center">
            <vs-col class="my-3"  vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
              <p class="emphasize">
                For now I will try some predefined dreams and later create my own.
              </p>

            </vs-col>
            <vs-col class="my-3" vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
              <ImportDreamDialog title="Choose From Template"/>
              </vs-col>
          </vs-row> -->

        </div>
        <draggable
            v-else
            :key="`${currentPeriod.getTime()}`"
            :list="dreams"
            class="vx-row"
            handle=".handle"
            ghost-class="ghost-dream"
        >
            <template v-for="dream in dreams">
                <div
                    :key="`dream_${dream.id}`"
                    :class="focusMode ? 'lg:w-1/4' : 'lg:w-1/4'"
                    class="vx-col w-full sm:w-1/3 mb-base"
                >
                    <Dream
                        v-if="dream"
                        :dream="dream"
                        :showGoalStats="!focusMode"
                        :focusMode="focusMode"
                        class="dream cursor-pointer"
                        :class="focusMode ? '' : $store.getters.handleClass"
                        @dblclick.prevent="editDreamDialog(dream)"
                        @detail="showDreamDetail(dream)"
                    />
                </div>
            </template>
        </draggable>
    </div>
    <Sidebar :initValue="sidebarActive" title="new dream" @close="sidebarActive=false">
      <EditForm
        class="pt-2"
        :editedEntity="{}"
        @close="sidebarActive=false"/>
    </Sidebar>
  </div>
</template>
<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import AddNew from './AddNew'
import EditForm from './EditForm'
import ImportDreamDialog from './ImportDreamDialog'
import Dream from './Dream'
import DreamsPreview from '../Preview/DreamsPreview'
import trackAnalytics from '@/helpers/trackAnalytics'
import Sidebar from '../Generic/Sidebar'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import PlannerHeader from '../Planner/PlannerHeader'

export default {
  components: {
    draggable,
    AddNew,
    EditForm,
    Dream,
    DreamsPreview,
    ImportDreamDialog,
    Sidebar,
    VuePerfectScrollbar,
    PlannerHeader
  },
  props: {
    focusMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    openDialog: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  data () {
    return {
      sidebarActive: false,
      editedEntity: null,
      dreams: [],
      dreamsLoading: false,
      dreamsOrder: {},
      dreamDefaults: {},
      importDreamDialogOpen: false,
      welcomeMessage: false,
    }
  },
  watch: {
    '$store.getters.dreams': {
      immediate: true,
      handler () {
        this.loadDreams()
      }
    },
    '$store.getters.goals': {
      immediate: true,
      handler () {
        this.loadDreams()
      }
    },
    'currentPeriod': {
      immediate: false,
      handler () {
        this.loadDreams()
      }
    },
    'dreams': {
      immediate: false,
      handler (dreams) {
        if (!this.dreamsLoading) {
          this.updateDreamsOrder(dreams)
        }
      }
    },
  },
  computed: {
    dreamsPresent () {
      return _.size(this.dreams) > 0
    },
    currentPeriod () {
      return this.$store.getters.currentPeriod
    }
  },
  methods: {
    async loadDreams () {
      this.dreamsLoading = true
      this.dreams = this.focusMode ? this.$store.getters.currentDreams : this.$store.getters.dreams

      setTimeout(() => { this.dreamsLoading = false }, 500)
    },
    // addDreamDialog () {
    //   this.editedEntity = this.dreamDefaults
    // },
    // editDreamDialog (dream) {
    //   this.editedEntity = dream
    // },
    // closeDreamDialog () {
    //   this.editedEntity = null
    //   this.loadDreams()
    // },
    showDreamDetail (dream) {
      this.$router.push({name: 'dream-detail', params: { dreamId: dream.id }})
    },
    updateDreamsOrder (dreams) {
      _.each(dreams, async (dream, order) => {
        await this.$store.dispatch('UPDATE_DREAM_ORDER', { dream, order })
      })
      trackAnalytics(this, 'app_action', 'change_dream_order', null, this.$store.getters.daysFromRegistration)
    },
    setImportDreamDialog (isOpen) {
      this.importDreamDialogOpen = isOpen
    }
  }
}
</script>
<style>
  .ghost-dream {
    opacity: 0.2;
  }

  .divider {
    margin-left: 30%;
    margin-right: 30%;
  }

  p.emphasize {
    font-size: 150%;
  }

</style>
